module.exports = __webpack_public_path__ + "img/tanxian.c25f79f0.jpg";